import React from 'react';
import Modal from './Modal';
import { FaSave, FaTimes } from 'react-icons/fa';

const FormModal = ({
  isOpen,
  onClose,
  title,
  children,
  onSave,
  saveLabel = 'Guardar',
  isSaving = false,
  size = 'medium',
  saveIcon = <FaSave />,
  showCancel = true,
  cancelLabel = 'Cancelar',
  saveButtonType = 'button',
  disabled = false,
  className = ''
}) => {
  const handleSave = (e) => {
    e.preventDefault();
    if (onSave && !isSaving && !disabled) {
      onSave();
    }
  };

  const footer = (
    <>
      {showCancel && (
        <button
          type="button"
          className="modal-btn modal-btn-secondary"
          onClick={onClose}
          disabled={isSaving}
        >
          <FaTimes /> {cancelLabel}
        </button>
      )}
      <button
        type={saveButtonType}
        className="modal-btn modal-btn-primary"
        onClick={saveButtonType === 'button' ? handleSave : undefined}
        disabled={isSaving || disabled}
      >
        {isSaving ? (
          <>
            <div className="spinner"></div>
            {typeof saveLabel === 'string' ? 'Guardando...' : saveLabel}
          </>
        ) : (
          <>
            {saveIcon} {saveLabel}
          </>
        )}
      </button>
    </>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size={size}
      footer={footer}
      className={className}
      closeOnOutsideClick={!isSaving}
      showCloseButton={!isSaving}
    >
      {saveButtonType === 'submit' ? (
        <form onSubmit={handleSave}>
          {children}
        </form>
      ) : (
        children
      )}
    </Modal>
  );
};

export default FormModal;